import { IAMessage } from './IAMessage'
import { TypeMessage } from '../../../../../interfaces'
import { IaMessages } from '../IaChat';

interface Props {
  messages: IaMessages[];
}

export const ContentOutputIA = ({ messages }: Props) => {

  return (
    <div className="ai-chat__out" id="contentIA">
      <div className="ai-chat__out-content">
        {
          messages.map((message, index) => {
            if(message.role === 'user') {
              return (<IAMessage key={index} text={message.content[0].text} type={TypeMessage.INPUT}/>)
            }else {
              return (<IAMessage key={index} text={message.content[0].text} type={TypeMessage.OUTPUT}/>)
            }
          })
        }
      </div>
    </div>
  )
}